export const MAXIMUM_INVENTORY_WEIGHT = 15
export const MAXIMUM_WORM_MAIL_BOX_SIZE = 10

export const NEWBIE_3_PIECE_SHOOT_AUGMENT_NAME = 'Newbie 3 Piece Shoot Augment'